module.exports = __webpack_public_path__ + "img/fig08.45ae35dc.jpg";